import axios from "axios";
import environment from "@/environment";

const api = axios.create({ baseURL: `${environment.API}/location` });

export const locationService = {
	checkLocationStatus: () => api.get("/")
};

export const dbConnected = {
	checkDbStatus: () => api.get("/dbStatus")
};

export const workerStatus = {
	checkSuntechWorker: () => api.get("/suntechWorkerStatus")
};

export const serverStatus = {
	checkSuntechServer: () => api.get("/suntechServerStatus")
};



export async function FetchLocationDashboard () {
	try {
		const response = await locationService.checkLocationStatus();
		return { ...response.data, statusCode: response.status };
	}
	catch (error) {
		if (error.response) {
			return {
				statusCode: error.response.status,
				problems: error.response.data.problems
			};
		}
		else {
			return {
				statusCode: 500,
				problems: ["Falha crítica de conexão"]
			};
		}
	}
}

export async function FetchDbDashboard () {
	try {
		const response = await dbConnected.checkDbStatus();
		return { ...response.data, statusCode: response.status };
	}
	catch (error) {
		if (error.response) {
			return {
				statusCode: error.response.status
			};
		}
		else {
			return {
				statusCode: 500
			};
		}
	}
}

export async function FetchWorkerDashboard () {
	try {
		const response = await workerStatus.checkSuntechWorker();
		return { ...response.data, statusCode: response.status };
	}
	catch (error) {
		if (error.response) {
			return {
				statusCode: error.response.status,
				message: error.response.data.message,
				pendingDocuments: error.response.data.pendingDocuments
			};
		}
		else {
			return {
				statusCode: 500
			};
		}
	}

}

export async function FetchServerDashboard () {
	try {
		const response = await serverStatus.checkSuntechServer();
		return { ...response.data, statusCode: response.status, lastLocation: response.data.lastLocation };
	}
	catch (error) {
		if (error.response) {
			return {
				statusCode: error.response.status,
				message: error.response.data.message,
				lastLocation: error.response.data.lastLocation
			};
		}
		else {
			return {
				statusCode: 500
			};
		}
	}

}